import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import routes, { renderRoutes } from './routes';

const App = () => {
  return <BrowserRouter basename={'/mm/wordpress/7540-2/'}>{renderRoutes(routes)}</BrowserRouter>;
};

export default App;
